import { render, staticRenderFns } from "./Disqualify.vue?vue&type=template&id=f80fc9a6&scoped=true&"
import script from "./Disqualify.vue?vue&type=script&lang=js&"
export * from "./Disqualify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80fc9a6",
  null
  
)

export default component.exports